var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.963,
    height: 21.6,
    viewBox: "0 0 17.963 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    transform: "translate(-2.2 -0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M11.182.2a8.992,8.992,0,0,1,8.982,8.982A10.281,10.281,0,0,1,18.787,14.1a19.128,19.128,0,0,1-2.934,3.931,27.461,27.461,0,0,1-4.228,3.638.8.8,0,0,1-.888,0A27.461,27.461,0,0,1,6.51,18.027,19.128,19.128,0,0,1,3.576,14.1,10.281,10.281,0,0,1,2.2,9.182,8.992,8.992,0,0,1,11.182.2Zm0,19.818c1.657-1.22,7.382-5.8,7.382-10.836a7.382,7.382,0,1,0-14.763,0C3.8,14.215,9.524,18.8,11.182,20.018Z",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    d: "M3-.8A3.8,3.8,0,1,1-.8,3,3.8,3.8,0,0,1,3-.8Zm0,6A2.2,2.2,0,1,0,.8,3,2.2,2.2,0,0,0,3,5.2Z",
    transform: "translate(8 6)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.48d1551108aff8ff2968134ecd79b5d0.svg";
export { ForwardRef as ReactComponent };